import { render, staticRenderFns } from "./report-AI-tzcp.vue?vue&type=template&id=00a582de&scoped=true&"
import script from "./report-AI-tzcp.vue?vue&type=script&lang=ts&"
export * from "./report-AI-tzcp.vue?vue&type=script&lang=ts&"
import style0 from "./report-AI-tzcp.vue?vue&type=style&index=0&id=00a582de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a582de",
  null
  
)

export default component.exports